import styled from 'styled-components';

export const LoadingDot = styled.img<{width?: number; height?: number; distance?: number}>`
    width: ${({width}) => width ?? 15}px;
    height: ${({height}) => height ?? 15}px;
    position: relative;
    animation: dotjump 300ms;
    animation-direction: alternate;
    animation-iteration-count: infinite;

    @keyframes dotjump {
        0% {
            top: -${({distance}) => distance ?? 5}px;
        }
        100% {
            top: ${({distance}) => distance ?? 5}px;
        }
    }
`;
